import { useState } from "react";
import { IconButton, Tooltip } from "@mui/material";
import QuickFilterModal from "./QuickFilterModal";
import QuickFilterIcon from "./QuickFilterIcon";

const QuickFilterButton = ({
  clientId,
  platform,
  pageId,
  filterConfig,
  campaignFilter = false,
  narrowFilters = false,
  onApply,
  tooltip = "Quick Filter",
  sx = {},
}) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Tooltip title={tooltip} arrow>
        <IconButton
          onClick={() => setOpen(true)}
          sx={{
            height: 36,
            width: 36,
            border: "1px solid",
            borderColor: "grey.400",
            borderRadius: 1,
            color: "#333333",
            "&:hover": {
              borderColor: "grey.700",
              backgroundColor: "grey.50",
            },
            ...sx,
          }}
        >
          <QuickFilterIcon fontSize={20} />
        </IconButton>
      </Tooltip>
      <QuickFilterModal
        open={open}
        onClose={() => setOpen(false)}
        clientId={clientId}
        platform={platform}
        pageId={pageId}
        filterConfig={filterConfig}
        campaignFilter={campaignFilter}
        narrowFilters={narrowFilters}
        onApply={onApply}
      />
    </>
  );
};

export default QuickFilterButton;
